"use client";

import { createContext, ReactNode } from "react";

import { UNSAFE_CLIENT_EXPOSED_ENVIRONMENT_VARIABLES as CLIENT_ENVIRONMENT_VARIABLES } from "./client";

export type ClientEnvironmentVariables = typeof CLIENT_ENVIRONMENT_VARIABLES;

export const ClientEnvironmentContext =
  createContext<ClientEnvironmentVariables | null>(null);

interface ClientEnvironmentProviderProps {
  children: ReactNode;
  environment: ClientEnvironmentVariables;
}

/**
 * this function replaces the protocol of EXTERNAL_ADDRESS in dev environment
 * to allow for the use of https while running the app locally
 */
export const replaceDevProtocol = (externalAddress: string) => {
  const isDev = externalAddress.includes("dev.peerspaceapp.com");
  const isHttps =
    typeof window !== "undefined" && window.location.protocol === "https:";

  if (isDev && isHttps) {
    return externalAddress.replace("http://", "https://");
  }

  return externalAddress;
};

export function ClientEnvironmentProvider({
  children,
  environment,
}: ClientEnvironmentProviderProps) {
  return (
    <ClientEnvironmentContext.Provider
      value={{
        ...environment,
        EXTERNAL_ADDRESS: replaceDevProtocol(environment.EXTERNAL_ADDRESS),
      }}
    >
      {children}
    </ClientEnvironmentContext.Provider>
  );
}
